module.exports = __webpack_public_path__ + "static/media/view5.0b453f73.jpg";